import { render, staticRenderFns } from "./AutorizacaoDiario.vue?vue&type=template&id=22c6e006&"
import script from "./AutorizacaoDiario.vue?vue&type=script&lang=js&"
export * from "./AutorizacaoDiario.vue?vue&type=script&lang=js&"
import style0 from "./AutorizacaoDiario.vue?vue&type=style&index=0&id=22c6e006&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports